__turbopack_context__.v({
  "className": "gamja_flower_81783604-module__U3izCG__className",
});
